import { Mercator, AlbersUsa } from '@visx/geo'
import { PROJECTION_TYPES } from './constants'

export const getProjectionComponent = (projectionType) => {
  switch (projectionType) {
    case PROJECTION_TYPES.ALBERS_USA:
      return AlbersUsa
    default:
      return Mercator
  }
}
